import React, { useEffect, useState } from 'react';
import { equipmentKinds, getEquipment } from '../../utils/equipment';

const empty = { name: '', kind: 'set_top_box', manufacturer: '', model: '' };

export default function EquipmentEditor({ areaId, onEquipmentChange }) {
  const [equipment, setEquipment] = useState([]);
  const [editingId, setEditingId] = useState('');
  const [draft, setDraft] = useState(empty);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const token = localStorage.getItem('token');

  useEffect(() => {
    let cancelled = false;
    setEquipment([]);
    setEditingId('');
    setDraft(empty);
    setMessage('');
    fetch(`/api/areas/${areaId}/equipment`, { headers: { Authorization: `Bearer ${token}` } })
      .then(async (response) => {
        const data = await response.json();
        if (!response.ok) throw new Error(data.message || 'Could not load equipment');
        if (!cancelled) {
          setEquipment(data.equipment || []);
          onEquipmentChange(data.equipment || []);
        }
      })
      .catch((error) => !cancelled && setMessage(error.message));
    return () => { cancelled = true; };
  }, [areaId, token, onEquipmentChange]);

  const save = async (event) => {
    event.preventDefault();
    setBusy(true);
    setMessage('');
    try {
      const response = await fetch(`/api/areas/${areaId}/equipment${editingId ? `/${editingId}` : ''}`, {
        method: editingId ? 'PUT' : 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(draft),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Could not save equipment');
      const next = [...equipment.filter((device) => Number(device.id) !== Number(data.equipment.id)), data.equipment];
      setEquipment(next);
      onEquipmentChange(next, data.equipment);
      setEditingId(String(data.equipment.id));
      setMessage('Equipment saved. Assign it to a Screen input or Audio Endpoint below, then save relationships.');
    } catch (error) {
      setMessage(error.message);
    } finally {
      setBusy(false);
    }
  };

  return <form className="topology-setup__screen" onSubmit={save}>
    <h4>Equipment without an app</h4>
    <p>Add physical equipment without installing Suitestream or creating an app token.</p>
    <label>Equipment<select value={editingId} disabled={busy} onChange={(event) => {
      setEditingId(event.target.value);
      const device = equipment.find((entry) => String(entry.id) === event.target.value);
      setDraft(device ? { ...empty, ...getEquipment(device), name: device.name } : empty);
      setMessage('');
    }}><option value="">Add equipment…</option>
      {equipment.map((device) => <option key={device.id} value={device.id}>{device.name}</option>)}
    </select></label>
    <label>Equipment name<input required maxLength={255} value={draft.name} disabled={busy}
      onChange={(event) => setDraft({ ...draft, name: event.target.value })} /></label>
    <label>Equipment kind<select value={draft.kind} disabled={busy}
      onChange={(event) => setDraft({ ...draft, kind: event.target.value })}>
      {equipmentKinds.map(([value, label]) => <option key={value} value={value}>{label}</option>)}
    </select></label>
    <label>Manufacturer (optional)<input maxLength={255} value={draft.manufacturer || ''} disabled={busy}
      onChange={(event) => setDraft({ ...draft, manufacturer: event.target.value })} /></label>
    <label>Model (optional)<input maxLength={255} value={draft.model || ''} disabled={busy}
      onChange={(event) => setDraft({ ...draft, model: event.target.value })} /></label>
    <label>Other names (comma-separated)<input value={(draft.aliases || []).join(', ')} disabled={busy}
      onChange={(event) => setDraft({ ...draft, aliases: event.target.value.split(',').slice(0, 20) })} /></label>
    <button type="submit" disabled={busy}>{busy ? 'Saving equipment…' : editingId ? 'Update equipment' : 'Add equipment'}</button>
    {message && <p role="status">{message}</p>}
  </form>;
}
